import React, { type FC, type ReactNode } from 'react'

type TabContentProps = {
  children: ReactNode
}

export const TabContent: FC<TabContentProps> = ({ children }) => {
  if (!children) {
    return null
  }
  return <div>{children}</div>
}
